import axios from 'axios'
import Service, { prepareURL } from '@/api/service'
import getFormDataFromJSON from '@/common/js/formdata'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

/*
    using '...Service('/url/:id/')' in object provides methods:
        fetch
        get
        delete
        put
        save
 */

export const SiteSettings = {
  update: payload => {
    return axios.put('/admin/core/settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/settings/', payload)
  }
}

export const HomepageSiteSettings = {
  update: payload => {
    return axios.put('/admin/core/homepage-settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/homepage-settings/', payload)
  }
}

export const Attachment = {
  ...Service('/admin/attachments/:id/'),
  upload: payload => {
    return axios.post('/admin/attachments/', payload, {
      headers: { 'content-type': 'multipart/form-data' }
    })
  }
}

export const RouteType = {
  fetch() {
    return axios.get('/admin/google-places/place-types-group/route_types/')
  }
}

export const Indicator = Service('/admin/datasets/indicators/:id/')

export const ReportItem = Service('/admin/datasets/reports/items/:id/')

export const Report = {
  ...Service('/admin/datasets/reports/:id/'),
  validate: payload => {
    return axios.post('/admin/datasets/reports/?validate=true', payload)
  }
}

export const Revision = Service('/admin/revisions/:id/')

export const Widget = {
  ...Service('/admin/widgets/:id/'),
  types(params) {
    return axios.get('/widgets/admin/types/', { params })
  },
  validate(payload) {
    return axios.post('/widgets/admin/validate/', payload)
  },
  available(params) {
    return axios.get('/widgets/admin/available/', { params })
  },
  preview(payload) {
    return axios.post('/widgets/admin/preview/', payload)
  }
}

export const Menu = {
  ...Service('/admin/menu/:id/')
}

export const CustomMenu = {
  ...Service('/admin/menu/customs/:id/')
}

export const Link = {
  availableLinkOptions() {
    return axios.get('/admin/links/available-options/')
  },
  availableWidgets(params) {
    return axios.get('/admin/links/available-widgets/', { params })
  }
}

export const Auth = {
  login(payload) {
    return axios.post('/public/users/auth/login/', payload)
  }
}

export const Image = {
  ...Service('/admin/images/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/admin/images/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    const formData = getFormDataFromJSON(payload)
    const defaultUpdate = Service('/admin/images/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  }
}

export const Video = {
  ...Service('/admin/videos/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/admin/videos/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    const formData = getFormDataFromJSON(payload)
    const defaultUpdate = Service('/admin/videos/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  }
}

export const User = {
  ...Service('/admin/users/:id/')
}

export const Dashboard = {
  getContentCounters() {
    return axios.get('/admin/dashboard/content-counters/')
  },
  getRecentPages() {
    return axios.get('/admin/dashboard/recent-pages/')
  },
  getUser() {
    return axios.get('/admin/dashboard/user/')
  }
}

export const Page = {
  ...Service('/admin/pages/:id/'),
  revision(params, payload) {
    const url = prepareURL(`/admin/pages/:id/revision/`, params)
    return axios.post(url, payload)
  },
  preview(urlParams, payload) {
    const url = '/admin/pages/:id/preview/'
    return axios.post(prepareURL(url, urlParams), payload)
  }
}

export const Article = {
  ...Service('/admin/articles/:id/'),
  preview(urlParams, payload) {
    const url = '/admin/articles/:id/preview/'
    return axios.post(prepareURL(url, urlParams), payload)
  },
  previewLink(urlParams, payload) {
    const url = '/admin/articles/:id/preview-link/'
    return axios.post(prepareURL(url, urlParams), payload)
  },
  revision(params, payload) {
    const url = prepareURL(`/admin/articles/:id/revision/`, params)
    return axios.post(url, payload)
  }
}

export const ArticleTag = {
  ...Service('/admin/articles/tags/:id/')
}

export const Label = {
  ...Service('/admin/articles/labels/:id/')
}
